import { Inject, Injectable } from '@angular/core';
import { BehaviorSubject, interval } from 'rxjs';
import { filter, mergeMap, startWith, take, takeWhile, tap, timeout } from 'rxjs/operators';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS, MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import {
  NotificationAction,
  NotificationActionTypeEnum,
  NotificationComponent,
  NotificationData,
  NotificationMessageTypeEnum
} from '../notification.component';

@Injectable({
  providedIn: 'root'
})
export class NoticeService {
  public callGetJobs = new BehaviorSubject<string>(null);

  get isEnabled(): boolean {
    //TODO (PTC 1.1): see OLPTC-3867
    //this._isEnabled = this.userAuth.getUserPref().enableWebUIAlerts;

    //we keep all messages enabled by default, until implementing
    // autonomous notifications feature in PTC 1.1
    this._isEnabled = true;
    return this._isEnabled;
  }

  set isEnabled(value: boolean) {
    this._isEnabled = value;
  }

  private _isEnabled: boolean;
  snackBarRef: MatSnackBarRef<NotificationComponent>;

  constructor(private readonly snackBar: MatSnackBar, @Inject(MAT_SNACK_BAR_DEFAULT_OPTIONS) public defaultOptions) {}

  private _openNotification(msg: string, type?: NotificationMessageTypeEnum, action?: NotificationAction) {
    if (this.isEnabled) {
      this.snackBarRef = this.snackBar.openFromComponent(NotificationComponent, {
        duration: action ? 600000 : this.defaultOptions.duration,
        data: {
          message: {
            text: msg,
            type: type
          },
          action: action
        },
        panelClass: [type]
      });
    }
  }

  private _startObserve(notificationData: NotificationData, jobType: string) {
    let status = notificationData.observer.condition[0];
    interval(5000)
      .pipe(
        startWith(0),
        take(120),
        takeWhile(() => {
          if (notificationData.observer.condition.find(c => c === status)) {
            return true;
          } else {
            //if(this.snackBarRef) this.snackBarRef.dismiss();
            return false;
          }
        }),
        mergeMap(() =>
          notificationData.observer.observable.pipe(
            timeout(60000),
            tap((result: { status: string }) => {
              status = result.status;
              if (notificationData.observer.exception && notificationData.observer.exception.length > 0) {
                if (notificationData.observer.exception.find(e => e === status)) {
                  //if(this.snackBarRef) this.snackBarRef.dismiss();
                  this.error(notificationData.observer.exceptionMsg);
                  this.callGetJobs.next(jobType);
                }
              }
            }),
            filter((result: { status: string }) => {
              if (notificationData.observer.limit.find(l => l === result.status)) return true;
              return false;
            }),
            tap((result: { status: string }) => {
              //if(this.snackBarRef) this.snackBarRef.dismiss();
              if (notificationData.observer.empty && notificationData.observer.empty === result.status) {
                this.warn(notificationData.observer.emptyMsg);
                this.callGetJobs.next(jobType);
              } else {
                switch (notificationData.action.type) {
                  case NotificationActionTypeEnum.FUNCTION:
                    notificationData.action.function.args.push(result);
                    break;
                  case NotificationActionTypeEnum.OBSERVABLE:
                    break;
                  case NotificationActionTypeEnum.NAVIGATION:
                    break;
                  case NotificationActionTypeEnum.CLOSE:
                    break;
                  default:
                    break;
                }
                this.success(notificationData.observer.successMsg, notificationData.action);
                this.callGetJobs.next(jobType);
              }
            })
          )
        )
      )
      .subscribe();
  }

  info(msg: string) {
    this._openNotification(msg, NotificationMessageTypeEnum.INFO);
  }

  success(msg: string, action?: NotificationAction) {
    this._openNotification(msg, NotificationMessageTypeEnum.SUCCESS, action);
  }

  error(msg: string) {
    this._openNotification(msg, NotificationMessageTypeEnum.ERROR);
  }

  warn(msg: string) {
    this._openNotification(msg, NotificationMessageTypeEnum.WARN);
  }

  warnWithClose(msg: string) {
    this._openNotification(msg, NotificationMessageTypeEnum.WARN, {
      name: 'close',
      type: NotificationActionTypeEnum.CLOSE
    });
  }

  normal(msg: string) {
    this._openNotification(msg);
  }

  successNotifyResult(notificationData: NotificationData, jobType: string) {
    this.info(notificationData.message.text);
    this._startObserve(notificationData, jobType);
  }
}
